import { BACKEND } from "../variables.js";
import axios from "axios";

const LIST_BY_HOUSE = BACKEND + "/parkingVehicles/listByHouse";
const GET_BY_TENANT = BACKEND + "/parkingVehicles/getByTenant";
const ADD = BACKEND + "/parkingVehicles/add";
const UPDATE = BACKEND + "/parkingVehicles/update";
const DELETE = BACKEND + "/parkingVehicles/delete";
const CHECK_PLATE = BACKEND + "/parkingVehicles/checkPlate";
const PARKING_CLIENTS = BACKEND + "/parkingVehicles/clients";

export default {
  actions: {
    ["GET_PARKING_VEHICLES_BY_HOUSE"](state, payload) {
      return axios({
        method: "POST",
        url: LIST_BY_HOUSE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["GET_PARKING_CLIENTS"](state, payload) {
      return axios({
        method: "POST",
        url: PARKING_CLIENTS,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["GET_PARKING_VEHICLES_BY_TENANT"](state, payload) {
      return axios({
        method: "POST",
        url: GET_BY_TENANT,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["ADD_PARKING_VEHICLE"](state, payload) {
      return axios({
        method: "POST",
        url: ADD,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["UPDATE_PARKING_VEHICLE"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["DELETE_PARKING_VEHICLE"](state, payload) {
      return axios({
        method: "POST",
        url: DELETE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["CHECK_PARKING_PLATE"](state, payload) {
      return axios({
        method: "POST",
        url: CHECK_PLATE,
        data: payload.data,
      });
    },
  },
};
